import { RecursoFiltro } from './../entity/recurso-filtro.model';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { CabecalhoMensagens, TipoMensagem, Situacoes } from 'app/entity/enumeraveis';
import { EventEmitterService } from 'app/util/emitter-service/emitter-service';
import { EVENT_MSGS_UPDATE } from 'app/util/emitter-service/nome-evento';
import * as FileSaver from 'file-saver';
import { SelectItem } from 'primeng/components/common/selectitem';
import { ConfirmationService, Message } from 'primeng/primeng';
// tslint:disable-next-line: import-blacklist
import { ReplaySubject } from 'rxjs';
import { Observable } from 'rxjs/Observable';

import { PadraoService } from '../service/padrao.service';
import { Helpers } from '../util/helpers';
import { Locale } from '../util/locale.ptbr';
import {
    bObservableListaPrestacaoConta,
    bObservableUsuario,
    ObservableBlockPanel,
    ObservableBlockPanelDoc,
    ObservableLotacao,
    ObservableVariable,
} from '../util/observable-util';
import { setImmediate } from 'timers';
import { dataFimLimite } from 'app/util/custom.validators';

@Component({ template: '' })
export class BaseComponent implements OnInit {
    controllerName = '';
    today = Date.now();
    hoje = new Date();
    dataLimitePrestacaoDeContas = new Date(`${new Date().getFullYear().toString()}/01/31`);
    primeiroDiaDoAnoAnteriorAoAnoVigente = new Date(`${(new Date().getFullYear() - 1).toString()}/01/01`);
    primeiroDiaDoAnoVigente = new Date(`${new Date().getFullYear().toString()}/01/01`);
    ultimoDiaDoAnoVigente = new Date(`${new Date().getFullYear().toString()}/12/31`);
    lastYear = new Date(new Date().setFullYear(new Date().getFullYear() - 1));
    msgs: Message[] = [];
    siglaUsuarioLogado: any;
    perfisLotado: any[];
    @Input() isValid = false;
    @Output() isValidChange = new EventEmitter<boolean>();
    profissionalPodePrestarConta = true;

    constructor(public formBuilder: FormBuilder,
        public router: Router,
        public activatedRoute: ActivatedRoute,
        public service: PadraoService,
        public observableUtil: ObservableVariable,
        public confirmacao: ConfirmationService,
        public locale: Locale,
        public help: Helpers,
        public observableUtilPanel: ObservableBlockPanel,
        public observableUtilPanelDoc: ObservableBlockPanelDoc,
        public observableUtilLotacao: ObservableLotacao,
        public observableUser: bObservableUsuario,
        public bObservableListaPrestacaoConta: bObservableListaPrestacaoConta
    ) {
        this.observableUser.getValue.subscribe(x => {
            if (x) {
                const dadoUsuario = x.obj
                this.perfisLotado = dadoUsuario.lotacaoDTO.find(x => x.id == localStorage.getItem('lotacao')).perfilDTO;
                this.siglaUsuarioLogado = dadoUsuario.lotacaoDTO.find(x => x.id == localStorage.getItem('lotacao')).sigla;
            }
        });
    }

    init(optional1?: any, optional2?: any) {
        if (sessionStorage.getItem('msg')) {
            this.showMsgSucess(sessionStorage.getItem('msg'))
        } else if (sessionStorage.getItem('msgError')) {
            this.showMsgError(sessionStorage.getItem('msgError'));
        } else if (sessionStorage.getItem('msgWarn')) {
            this.showMsgWarn(sessionStorage.getItem('msgWarn'));
        }
        sessionStorage.removeItem('msg');
        sessionStorage.removeItem('msgError');
        sessionStorage.removeItem('msgWarn');
    };
    afterInit() { };
    afterLoad() { };

    ngOnInit() {
        this.init();
    }

    get ehGestorEpc() {
        return this.gestorCfc || this.gestorCrc
    }

    get gestorCfc() {
        return this.perfisLotado && this.perfisLotado
            .some(x => x.sistemaDTO.nome.toLowerCase() === 'epc' && x.nome.toLowerCase() === 'gestor cfc');
    }

    get gestorCrc() {
        return this.perfisLotado && this.perfisLotado
            .some(x => x.sistemaDTO.nome.toLowerCase() === 'epc' && x.nome.toLowerCase() === 'gestor crc');
    }

    get comissaoCfc() {
        return this.perfisLotado && this.perfisLotado
            .some(x => x.sistemaDTO.nome.toLowerCase() === 'epc' && x.nome.toLowerCase() === 'comissão cfc');
    }

    get comissaoCrc() {
        return this.perfisLotado && this.perfisLotado
            .some(x => x.sistemaDTO.nome.toLowerCase() === 'epc' && x.nome.toLowerCase() === 'comissão crc');
    }
    get ehCapacitadora() {
        return this.perfisLotado && this.perfisLotado
            .some(x => x.sistemaDTO.nome.toLowerCase() === 'epc' &&
                (x.nome.toLowerCase() === 'capacitadora'));
    }

    get ehProfissional() {
        return this.perfisLotado && this.perfisLotado
            .some(x => x.sistemaDTO.nome.toLowerCase() === 'epc' &&
                (x.nome.toLowerCase() === 'profissional'));
    }

    getItemBy(arr: any, filter: any) {
        if (arr == null) {
            return '';
        }
        const ret = arr.find(item => {
            let select = true;
            Object.keys(filter).forEach(fkey => {
                if (select && item[fkey] !== filter[fkey]) {
                    select = false;
                }
            });
            return select;
        });
        return ret ? ret : '';
    }

    listItemBy(arr: any, filter: any) {
        if (arr == null) {
            return [];
        }
        const ret = arr.filter(item => {
            let select = true;
            Object.keys(filter).forEach(fkey => {
                if (select && item[fkey] !== filter[fkey]) {
                    select = false;
                }
            });
            return select;
        });
        return ret ? ret : [];
    }

    showMsg(severity: string, summary: string, detail: string) {
        this.msgs = [];
        this.msgs.push({ severity: severity, summary: summary, detail: detail });
        EventEmitterService.get(EVENT_MSGS_UPDATE).emit(this.msgs);
    }

    showMsgError(mensagem: string) {
        this.showMsg(TipoMensagem[4], CabecalhoMensagens[4], mensagem);
    }

    showMsgWarn(mensagem: string) {
        this.showMsg(TipoMensagem[3], CabecalhoMensagens[3], mensagem);
    }

    showMsgInfo(mensagem: string) {
        this.showMsg(TipoMensagem[2], CabecalhoMensagens[5], mensagem);
    }

    showMsgSucess(mensagem: string) {
        this.showMsg(TipoMensagem[1], CabecalhoMensagens[1], mensagem);
    }

    touchAll(formGroup: FormGroup | FormArray, func = 'markAsDirty', opts = { onlySelf: false }): void {
        Object.keys(formGroup.controls).map((key, index) => {
            const obj = formGroup.controls[key];
            if (obj instanceof FormGroup || obj instanceof FormArray) {
                this.touchAll(obj, func, opts);
            } else {
                obj[func](opts);
            }
        });
    }

    setValidators(formGroup: FormGroup | FormArray, validator: any): void {
        Object.keys(formGroup.controls).map((key, index) => {
            const obj = formGroup.controls[key];
            if (obj instanceof FormGroup || obj instanceof FormArray) {
                this.setValidators(obj, validator);
            } else {
                obj.setValidators(validator);
            }
        });
    }

    verifyControlsEmpty(formGroup: FormGroup | FormArray, controlNameExcept?: string): boolean {
        let count = 0;
        Object.keys(formGroup.controls).map((key, index) => {
            const obj = formGroup.controls[key];
            if ((obj.value === undefined || obj.value === null || obj.value === '') && controlNameExcept !== key) {
                count++;
            }
        });
        if (count > 0) { return false; } else { return true; }
    }

    validateListExists(list: any, obj: any) {
        if (this.getItemBy(list, obj) != '') {
            this.showMsgWarn(`Já existe um registro na lista com esses dados.`)
            return true;
        } else {
            return false;
        }
    }

    addToList(list: any, listEmit: EventEmitter<any>, form: any, event: any, validationObj: any = null, customData: any = null) {
        if (validationObj != null && this.validateListExists(list, validationObj)) {
            return false;
        }
        if (form.valid) {
            // tslint:disable-next-line: max-line-length
            if (list.length > 0 ? form.value.id_funcao_exercida !== undefined ?
                !list.some(x => x.id_funcao_exercida === form.value.id_funcao_exercida 
                             && x.id_pontuacao === form.value.id_pontuacao 
                             && x.id_grupo_atividade === form.value.id_grupo_atividade
                             && x.id_hipoteses === form.value.id_hipoteses) : true : true)
            {
                list.push(Object.assign({}, form.value, customData));
                list = [...list];
                listEmit.emit(list);

                form.reset();
                this.touchAll(form, 'markAsPristine');
            } else {
                this.showMsg(TipoMensagem[3], CabecalhoMensagens[3], 'Não é possível adicionar Função Exercida com a mesma Hipótese Legal já incluída anteriormente.')
                this.touchAll(form);
                return false;
            }
        } else {
            this.touchAll(form);
            return false;
        }

    }

    editElementToList(list: any[], listEmit: EventEmitter<any>, index: number, form: FormGroup) {
        let dado: any;
        dado = list.splice(index, 1);
        form.patchValue(dado[0]);
        list = [...list];
        listEmit.emit(list);
        return dado[0];
    }

    removeFromList(list: any[], listEmit: EventEmitter<any>, index: number, message: string, minLength: number = 0) {
        this.confirmacao.confirm({
            header: 'Mensagem de Confirmação',
            message: `Atenção! Deseja mesmo remover esse item da lista ${message}?`,
            accept: () => {
                list.splice(index, 1);
                list = [...list];
                listEmit.emit(list)
                if (list.length < minLength) {
                    this.showMsgWarn(`É necessária a inclusão de ao menos ${minLength} ${message}`);
                }
            }
        });
    }
    loadEnumAsList(enumeration: any): any {
        const half = typeof enumeration == 'object' ? (Object.keys(enumeration).length * 0.5) : enumeration.length;
        return Object.keys(Object.assign({}, enumeration))
            .filter((key, i) => (i < half)).map((key, i, obj) => obj[key] = { value: key, label: obj[key] });
    }

    /**
     * Preenche uma lista a partir de um enum passado pelo usuario
     * @param lista lista a ser preenchida
     * @param enumeration enum a ser usada para preencher a lista
     */
    loadListAsEnum(lista: SelectItem[], enumeration: any) {
        for (var n in enumeration) {
            if (isNaN(Number(n))) {
                lista.push({ value: <any>enumeration[n], label: n });
            }
        }
    }


    getControlName(c: AbstractControl): string | null {
        const formGroup = c.parent.controls;
        return Object.keys(formGroup).find(name => c === formGroup[name]) || null;
    }

    limpaCaracterEspecial(campo: string): string {
        if (campo != null) {
            return campo.replace(/[^0-9A-Za-z]/g, '');
        } else { return ''; }
    }

    FormatCodigoCFC(campo: string): string {
        if (campo != null) {
            return campo.replace(/[^0-9A-Za-z\-]/g, '');
        } else { return ''; }
    }

    public readFile(fileToRead: File): Observable<MSBaseReader> {
        const base64Observable = new ReplaySubject<MSBaseReader>(1);

        const fileReader = new FileReader();
        fileReader.onload = event => {
            base64Observable.next(fileReader.result);
        };
        fileReader.readAsDataURL(fileToRead);

        return base64Observable;
    }

    b64toFile(b64Data, filename, contentType) {
        const sliceSize = 512;
        const byteCharacters = atob(b64Data);
        const byteArrays = [];

        for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            const slice = byteCharacters.slice(offset, offset + sliceSize);
            const byteNumbers = new Array(slice.length);

            for (let i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }
        const file = new File(byteArrays, filename, { type: contentType });
        return file;
    }

    downloadFile(id: number, fileName: string, key: string, classtype: string) {
        this.service.ObterAnexo(`arquivo`, id, key, classtype).subscribe(
            data => {
                FileSaver.saveAs(this.b64toFile(data, null, 'application/octet-stream'), fileName);
                this.showMsgSucess(`O arquivo '${fileName}' foi baixado automaticamente, verifique na pasta de downloads.`);
            }
            , err => this.showMsgError(`Houve um erro ao baixar o arquivo. ${err._body}`)
        );
    }

    downloadFileById(id: number, key: string, fileName: string) {
        this.observableUtilPanelDoc.setBlockedPanel(true);
        this.service.ObterAnexoById(`anexo/download`, id, key).subscribe(
            data => {
                this.observableUtilPanelDoc.setBlockedPanel(false);
                FileSaver.saveAs(new Blob([data.blob()], { type: data['_body'].type }), fileName);
                this.showMsgSucess(`O arquivo '${fileName}' foi baixado automaticamente, verifique na pasta de downloads.`);
            }
            , err => {
                this.observableUtilPanelDoc.setBlockedPanel(false);
                this.showMsgError(`Houve um erro ao baixar o arquivo.`);
            }
        );
    }

    onSelectFileUploadList(event, uploadedFiles: any[], uploadedFilesChange: EventEmitter<any[]>,
        customData: any = null) {
        for (const file of event.files) {
            if (file.size < 10000000) {
                this.readFile(file).subscribe(f => {
                    uploadedFiles.push(Object.assign({
                        nome_upload: f, nome_arquivo: file.name,
                        tamanho_arquivo: file.size, extensao: null, id: 0
                    }, customData));
                    uploadedFiles = [...uploadedFiles];
                    uploadedFilesChange.emit(uploadedFiles);
                });
            }
        }
    }
    IncluirArquivo(file, uploadedFiles: any[], uploadedFilesChange: EventEmitter<any[]>,
        customData: any = null) {
        if (file.size < 10000000) {
            this.readFile(file).subscribe(f => {
                uploadedFiles.push(Object.assign({
                    nome_upload: f, nome_arquivo: file.name,
                    tamanho_arquivo: file.size, extensao: null, id: 0
                }, customData));
                uploadedFiles = [...uploadedFiles];
                uploadedFilesChange.emit(uploadedFiles);
            });
        }
    }

    adicionaZeroEsquerda(num, size) {
        let s = num + '';
        while (s.length < size) { s = '0' + s; }
        return s;
    }


    concatStringFiltro(list: any[]) {
        let string = '';
        let primeira = false;
        list.forEach(x => {
            if (!primeira) {
                string = string.concat(x);
                primeira = true;
            } else {
                string = string.concat(' ', x);
            }
        });

        return string;
    }

    salvarEstadoPaginacao(pagina: number) {
        sessionStorage.setItem('funcionalidade', this.router.url.split('/')[2]);
        sessionStorage.setItem('pagina', pagina.toString());
    }

    logar(obj: any) {
    }

    calcularValidadeCurso(data_cadastro: string, data_validade: string) {
        // if(data_validade){
        //     var d = new Date(data_validade),
        //     month = '' + (d.getMonth() + 1),
        //     day = '' + d.getDate(),
        //     year = d.getFullYear();

        // if (month.length < 2) 
        //     month = '0' + month;
        // if (day.length < 2) 
        //     day = '0' + day;

        // return [day, month, year].join('/');
        // }
        if (data_cadastro != null) {
            const data = new Date(data_cadastro);
            const ano: number = data.getFullYear() + 1;
            return '31/12/' + ano;
        }
        return null;
    }

    gerarData(data: string): Date {
        return data ?
            new Date(data.replace(/[/]/g, '-').replace(/(\d{2})-(\d{2})-(\d{4})/, '$2/$1/$3'))
            : null;
    }
    /**
     * Retorn um arquivo
     * @param id id da entidade a ser impressa
     * @param fileName nome do arquivo que será salvo
     * @param controller controlador a ser chamado
     * @param action ação a ser chamada
     */
    printById(id: number, fileName: string, controller: string, action: string) {

        this.confirmacao.confirm({
            header: 'Confirmação',
            message: `Deseja realmente imprimir?`,
            accept: () => {
                this.observableUtilPanelDoc.setBlockedPanel(true);
                this.service.GetFileById(id, controller, action, null).subscribe(
                    x => {
                        FileSaver.saveAs(new Blob([x.blob()], { type: x['_body'].type }), fileName);
                        this.showMsg('success', 'Mensagem de Sucesso', `Impressão realizada com sucesso.`);
                        this.observableUtilPanelDoc.setBlockedPanel(false);
                    },
                    err => {
                        this.showMsg('danger', 'Mensagem de Erro', `Houve algum erro ao imprimir. ${err}`);
                        this.observableUtilPanelDoc.setBlockedPanel(false);
                    }
                );
            }
        });
    }

    /**
     * Está função é usada para quando náo se deseja abrir um recurso de uma atividade
     * @param id id da atividade para o qual o recurso não será aberto
     * @param route rota do controller para a função não-interpor-recurso
     * @param retornoLink link de retorno ao final da execução
     */
    naoAbrirRecurso(id: number, route: string, refresh: boolean, timeOut: number = 0) {
        setTimeout(() => {
            this.confirmacao.confirm({
                header: 'Confirmação',
                message: `Concordo com a decisão proferida pelo CRC/CFC. Não desejo interpor recurso.`,
                accept: () => {
                    this.observableUtilPanelDoc.setBlockedPanel(true);
                    const body = new RecursoFiltro();
                    body.IdModel = id
                    body.Interpor = false;
                    this.service.InteporRecurso(body, route).subscribe(() => {
                        this.showMsgSucess('Recurso não interposto com sucesso.');
                        this.observableUtilPanelDoc.setBlockedPanel(false);
                        if (refresh !== null) {
                            setTimeout(() => location.reload(), 3000);
                        }
                    },
                        err => {
                            this.showMsgError(`Houve um erro ao salvar o registro.<br> ${err._body}`)
                            this.observableUtilPanelDoc.setBlockedPanel(false);
                            this
                        });
                }
            });
        }, timeOut);
    }
    /**
     * Está função é usada para quando se deseja abrir um recurso de uma atividade
     * @param body dados do recurso a ser aberto
     * @param controller rota do controller para a função não-interpor-recurso
     * @param retornoLink link de retorno ao final da execução
     */
    abrirRecurso(body: RecursoFiltro, controller: string, retornoLink: string = null) {
        body.Interpor = true;
        if (body.Justificativa.length === 0) {
            this.showMsgWarn('É necessário justificativa para interpor recurso.');
            return;
        }
        this.confirmacao.confirm({
            header: 'Confirmação',
            message: 'Não concordo com a decisão proferida pelo CRC/CFC e desejo interpor recurso.',
            accept: () => {
                this.observableUtilPanelDoc.setBlockedPanel(true);
                this.service.InteporRecurso(body, controller).subscribe(() => {
                    this.observableUtilPanelDoc.setBlockedPanel(false);
                    this.showMsg('success', 'Mensagem de Aviso', `Recurso interposto com sucesso.`);
                    if (retornoLink !== null) {
                        this.router.navigate([retornoLink]);
                    }
                },
                    err => {
                        this.showMsgError(`Houve um erro ao salvar o registro.<br> ${err._body}`)
                        this.observableUtilPanelDoc.setBlockedPanel(false);
                    });
            }
        });
    }

    DataSemHora(data) {
        const d = new Date(data);
        d.setHours(0, 0, 0, 0);
        return d;
    }

    prestacaoForaDoPrazo(data: Date): boolean {
        const anoExercicio = data.getFullYear();
        var retorno: boolean = false;
        retorno = (anoExercicio == 2019 || anoExercicio == 2020) &&
            this.ehProfissional &&
            this.DataSemHora(new Date()) > this.DataSemHora(new Date(2021, 3, 31));
        retorno = this.ehProfissional &&
        (anoExercicio  != 2019 && anoExercicio != 2020) &&
        this.DataSemHora(new Date()) > this.DataSemHora(new Date(anoExercicio + 0, 1, 7));
        return retorno;
    }
    prestacaoForaDoPrazoObj(obj: any): boolean {
        return (!obj || obj.id_situacao !== Situacoes['Devolvido para Adequação']);
    }

    desconsiderarForaDoPrazoObj(obj: any): boolean {
        return (!obj || obj.id_situacao !== Situacoes['Devolvido para Adequação'] || obj.id_situacao !== Situacoes['Aberto para Recurso']);
    }
 

    verificarPrestacaoForaDoPrazo(data: Date, cadastro: FormGroup){
        this.service.temPendencia(data.getFullYear()).subscribe(pendencia => {
            this.service.obterPrazoPrestacaoProfissional(data.getFullYear()).subscribe((prazo: string) => {
                var foraDoPrazo: boolean = false;
                foraDoPrazo = this.ehProfissional && this.DataSemHora(new Date()) > this.DataSemHora(prazo);
                let fim = new Date(cadastro.get('data_fim').value);
                let id_situacao = cadastro.get('id_situacao').value
                if (data && foraDoPrazo && !pendencia && (id_situacao != 13 && id_situacao != 14)) {
                    const anoPrestacao = data.getFullYear();
                    this.exibirPrestacaoForaDoPrazo(anoPrestacao);
                    this.profissionalPodePrestarConta = false;
                    cadastro.get('data_fim').setErrors({ error: `Prestação do ano ${anoPrestacao} já encerrada` });
                }
                else if (!dataFimLimite(fim)) {
                    cadastro.get('data_fim').setErrors({ error: `Não é possível cadastrar esta atividade para o ano seguinte.` });
                    this.showMsg('warn', 'Data Fim', `Não é possível cadastrar esta atividade para o ano seguinte.`);
                }
            });
        });
    }

    exibirPrestacaoForaDoPrazo(ano: number) {
        this.showMsgWarn(`A data limite para prestar contas foi atingida. Entre em contato com o CFC para obter mais informações.`);
        // this.showMsgWarn(`A data limite para prestar contas do ano de ${ano} é 31/01/${ano + 1}`);
    }

    retornaDataString(data: Date, isFormatBrazil: boolean = false): string {

        if (!data) { return null };
        const dia = data.getDate().toString(),
            mes = (data.getMonth() + 1).toString(), // + 1 pois no getMonth Janeiro começa com zero.
            ano = data.getFullYear();

        return isFormatBrazil ? `${dia}/${mes}/${ano}` : `${mes}-${dia}-${ano}`;
    }

    agruparLista(lista: Array<any>, chaveAgrupamento: string): object {
        return lista.reduce((rv, x) => {
            (rv[x[chaveAgrupamento]] = rv[x[chaveAgrupamento]] || []).push(x);
            return rv;
        }, {});
    }

    GetItemLista(id: number, list: any[]): string {
        if (id && id > 0 && list && list.length > 0) {
            return list.find(x => x.value === id).label
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/base/base.component.ts